import {Box, Switch, Typography} from "@mui/material";
import {useGetQueryParam} from "../../utils/navigation/useQueryParam";
import {FilterType} from "../../config/enums";
import {strokeTheme} from "../../config/themes/theme";

export default function FilterSwitch() {
  const feature = useGetQueryParam(FilterType.FEATURE);
  const showFaqToggle = feature === "PYQ";

  return (
    <>
      {showFaqToggle && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            border: strokeTheme,
            borderRadius: "12px",
            ml: 1,
            px: 1,
          }}>
          <Typography variant="caption" fontWeight="bold" sx={{mb: 0}}>
            FAQs
          </Typography>
          <Switch color="primary" size="small" sx={{mt: -0.5}} />
        </Box>
      )}
    </>
  );
}
